module.exports = __webpack_public_path__ + "assets/00f7e4f2799f58011a60c998021829b3.mp3";